import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { ContentBookmark } from "~/components/content/content-bookmark";

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
`;

export type ContentBookmarkProps = {
  $variant?: "light" | "dark";
};
export const StyledContentBookmark = styled(ContentBookmark)<ContentBookmarkProps>`
  inline-size: 25px;
  block-size: 28px;
  padding: 0;

  path {
    ${props =>
      props.$variant === "dark"
        ? css`
            fill: #ffffff;
          `
        : css`
            fill: #001246;
          `}
  }
`;
